import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';

export interface OCSortingFieldOption {
  key: string;
  value: string;
}

export const getOCSortingFieldsAPI = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.OVERCHARGE_CLAIM}/GetSortColumns`,
  });
};

export type OCSortingFieldsResponse = OCSortingFieldOption[];

export const fetchOCSortingFields = async (): Promise<OCSortingFieldsResponse> => {
  const response: AxiosResponse<OCSortingFieldsResponse> = await getOCSortingFieldsAPI();
  return response.data;
};
